import React from 'react';
import { useStyletron } from 'baseui';
import { CustomColumn } from 'baseui/data-table';

import { CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	presignedUrl: 'presignedUrl',
	timestamp: 'timestamp'
};

export const columnConfigs = [
	CustomDateColumn({
		title: 'Uploaded At',
		maxWidth: 200,
		columnName: COL_NAMES.timestamp
	}),
	CustomColumn({
		title: 'Document Image',
		minWidth: 400,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.presignedUrl],
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<a href={value} target='_blank' rel='noreferrer'>
					<img src={value} alt='' className={css({ height: '170px' })} />
				</a>
			);
		}
	})
];
